export default function LandingPage() {
    return (
        <section></section>
    )
}
